export const InterestReportTypes = {
    GET_INTEREST_REPORT:'GET_INTEREST_REPORT',
}